import { createReducer } from '@reduxjs/toolkit';

import { DocumentsStateType } from '../../types';
import {
  getDocument,
  getDocuments,
  setDocumentsLoading,
} from '../actions/documents';

const initialState: DocumentsStateType = {
  loading: {
    documents: false,
    document: false,
    documentPDF: false,
  },
  data: {
    pagination: {
      isFirst: true,
      isLast: false,
    },
    documents: [],
    document: undefined,
  },
};

const documentsReducer = createReducer(initialState, (builder) => {
  builder.addCase(setDocumentsLoading, (state, action) => {
    state.loading[action.payload.type] = action.payload.value;
  });

  builder.addCase(getDocuments.fulfilled, (state, action) => {
    if (action.payload) {
      if (action.payload.concat) {
        if (action.payload.pagination.isFirst) {
          state.data.documents = action.payload.documents;
        } else {
          state.data.documents = state.data.documents.concat(
            action.payload.documents
          );
        }
      } else {
        state.data.documents = action.payload.documents;
      }
      state.data.pagination.isFirst = action.payload.pagination.isFirst;
      state.data.pagination.specialFields =
        action.payload.pagination.specialFields;
      state.data.pagination.isLast = action.payload.pagination.isLast;
      state.data.pagination.total = action.payload.pagination.total;
    }
  });

  builder.addCase(getDocument.fulfilled, (state, action) => {
    if (action.payload) state.data.document = action.payload;
  });
});

export default documentsReducer;
